import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class InscricaoErrorInterceptor implements HttpInterceptor {

  private readonly mensagensErro: Record<number, string> = {
    409: 'Este e-mail já está cadastrado. Tente fazer login.',
    403: 'Voce não tem permissão para acessar este recurso.',
    410: 'Este link de inscrição expirou ou nao esta mais disponivel.',
    404: 'O recurso solicitado não foi encontrado.',
    500: 'Erro interno do servidor. Tente novamente mais tarde.'
  };

  constructor(
    private messageService: MessageService,
    private router: Router
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.url && error.url.includes('/inscricao/autosave')) {
          return throwError(error);
        }

        // Não tratar erros de autenticação — o componente de login cuida disso
        // O body pode ser objeto {informacoes: ...} ou string serializada "informacoes=..."
        const body = request.body;
        const isLoginRequest =
          (body && typeof body === 'object' && 'informacoes' in body) ||
          (typeof body === 'string' && body.includes('informacoes'));
        if (isLoginRequest) {
          return throwError(error);
        }

        // Para erros 422 com erros categorizados de validação de inscrição,
        // deixar o componente (TermosAceiteComponent) exibir o painel detalhado
        if (error.status === 422 && error.error?.erros) {
          return throwError(error);
        }

        const mensagem = this.mensagensErro[error.status]
          || error.error?.message
          || 'Ocorreu um erro inesperado.';

        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: mensagem,
          life: 5000
        });

        if (error.status === 410) {
          this.router.navigate(['/inscricao/login']);
        }

        return throwError(error);
      })
    );
  }
}
